export const RESPONSIVE_FILTER_OPEN = `Фильтр`;
export const RESPONSIVE_FILTER_CLOSE = `Закрыть`;
export const PRODUCT_NUMBER_FORMS = [
  `товар`,
  `товара`,
  `товаров`
];
export const SHOW_TEXT = `Показать`;
export const RESPONSIVE_RESET_BUTTON_TEXT = `Сбросить`;
